import Vue from 'vue'
import Router from 'vue-router'

// Global
import Login from '@/components/commons/Login'
const Home = () => import('@/components/leaders/Home');
const Collection = () => import('@/components/leaders/Collection');
const CollectionRole = () => import('@/components/includes/collection/Role');


// Entity
const Entity = () =>  import('@/components/leaders/Entity');
const EntityDashboard = () =>  import('@/components/leaders/entity/EntityDashboard');
const Members = () =>  import('@/components/leaders/entity/Members');
const JoinRequests = () =>  import('../components/leaders/entity/JoinRequests.vue');
const Entities = () =>  import('@/components/leaders/entity/Entities');
const Calendar = () =>  import('@/components/leaders/entity/Calendar');
const Announcements = () =>  import('@/components/leaders/entity/Announcement/Announcements');
const AnnouncementsView = () =>  import('@/components/leaders/entity/Announcement/ViewAnnouncements');
const NewAnnouncement = () =>  import('@/components/leaders/entity/Announcement/NewAnnouncement');
const AnnouncementEdit = () =>  import('@/components/leaders/entity/Announcement/AnnouncementEdit');
const Events = () =>  import('@/components/leaders/entity/Events');
const Contributions = () =>  import('@/components/leaders/entity/Contributions');
const MyCongress = () =>  import('@/components/leaders/entity/MyCongress');
const Configuration = () =>  import('@/components/leaders/entity/Configuration');
const EntityRole = () =>  import('@/components/leaders/entity/Role');

// Members
const MemberProfile = () => import('@/components/leaders/entity/MemberProfile/Profile');
const MemberNotes = () => import('@/components/leaders/entity/MemberProfile/Notes');

// Resources
const Resources = () => import('@/components/leaders/entity/Resources/Index');
const ResourcePhotos = () => import('@/components/leaders/entity/Resources/Photos');
const PhotosAlbumView = () => import('@/components/leaders/entity/Resources/PhotosAlbumView');
const NewAlbum = () => import('@/components/leaders/entity/Resources/NewAlbum');
const PhotosAlbumEdit = () => import('@/components/leaders/entity/Resources/EditAlbum');

const ResourceAudios = () => import('@/components/leaders/entity/Resources/Audios');
const AudioAdd = () => import('@/components/leaders/entity/Resources/AudioAdd');
const AudioView = () => import('@/components/leaders/entity/Resources/AudioView');

const ResourceVideos = () => import('@/components/leaders/entity/Resources/Videos');
const VideoView = () => import('@/components/leaders/entity/Resources/VideoView');
const AddVideo = () => import('@/components/leaders/entity/Resources/AddVideo');

const ResourceDocs = () => import('@/components/leaders/entity/Resources/Docs');
const AddDocument = () => import('@/components/leaders/entity/Resources/AddDocument');
const DocumentView = () => import('@/components/leaders/entity/Resources/DocumentView');

const Links = () => import('@/components/leaders/entity/Resources/Links');
const LinkAdd = () => import('@/components/leaders/entity/Resources/LinkAdd');
const LinkView = () => import('@/components/leaders/entity/Resources/LinkView');

// Profile
const About = () => import('@/components/profile/about');
const Contact = () => import('@/components/profile/contact');
const Citizenship = () => import('@/components/profile/citizenship');
const Family = () => import('@/components/profile/family');
const Membership = () => import('@/components/profile/membership');
const Employments = () => import('@/components/profile/employments');
const Educations = () => import('@/components/profile/educations');
const Skills = () => import('@/components/profile/skills_new');
const Social = () => import('@/components/profile/social');

// Collection Profile
const CollectionProfile = {
    Landing: () => import('@/components/leaders/Collection/Landing'),
    Profile: () => import('@/components/leaders/Collection/Profile/Profile'),
    About: () => import('@/components/leaders/Collection/Profile/About'),
    Contact: () => import('@/components/leaders/Collection/Profile/Contact'),
    Citizenship: () => import('@/components/leaders/Collection/Profile/Citizenship'),
    Membership: () => import('@/components/leaders/Collection/Profile/Membership'),
    Employments: () => import('@/components/leaders/Collection/Profile/Employments'),
    Educations: () => import('@/components/leaders/Collection/Profile/Educations'),
    Skills: () => import('@/components/leaders/Collection/Profile/Skills'),
    Social: () => import('@/components/leaders/Collection/Profile/Social'),
}

Vue.use(Router)

export default new Router({
    mode: 'history',
    linkActiveClass: 'active',
    base: __dirname,
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login,
            meta: { requiresAuth: false }
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Home,
            meta: { requiresAuth: true }
        },
        {
            path: '/collection/:collection_id',
            name: 'collection',
            component: Collection,
            props: true,
            meta: { requiresAuth: true }
        },
        {
            path: '/collection/:collection_id/roles',
            name: 'collection.roles',
            component: CollectionRole,
            props: true,
            meta: { requiresAuth: true }
        },
        {
            path: '/collection/:collection_id/entity/:entity_id',
            component: Entity,
            props: true,
            meta: { requiresAuth: true },
            children: [
                {
                    path: 'members',
                    name: 'entity.members',
                    component: Members,
                    props: true,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'join-requests',
                    name: 'entity.joinRequests',
                    component: JoinRequests,
                    props: true,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'dashboard',
                    name: 'entity.dashboard',
                    component: EntityDashboard,
                    props: true,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'entities',
                    name: 'entity.entities',
                    component: Entities,
                    props: true,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'members/:id',
                    component: MemberProfile,
                    props: true,
                    meta: { requiresAuth: true },
                    children: [
                        {
                            path: 'about',
                            name: 'profile.index',
                            component: About,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'contact',
                            name: 'profile.contact',
                            component: Contact,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'citizenship',
                            name: 'profile.citizenship',
                            component: Citizenship,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'family',
                            name: 'profile.family',
                            component: Family,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'membership',
                            name: 'profile.membership',
                            component: Membership,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'employment',
                            name: 'profile.employments',
                            component: Employments,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'education',
                            name: 'profile.educations',
                            component: Educations,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'skills',
                            name: 'profile.skills',
                            component: Skills,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'social',
                            name: 'profile.social',
                            component: Social,
                            meta: { requiresAuth: true },
                        }
                    ]
                },
                {
                    path: 'member/:id/notes',
                    component: MemberNotes,
                    name: 'member.notes',
                    props: true,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'calendar',
                    name: 'entity.calendar',
                    component: Calendar,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'announcements',
                    name: 'entity.announcements',
                    component: Announcements,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'announcements/new',
                    name: 'entity.announcements.new',
                    component: NewAnnouncement,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'announcements/:announcement_id/view',
                    name: 'entity.announcements.view',
                    component: AnnouncementsView,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'announcements/:announcement_id/edit',
                    name: 'entity.announcements.edit',
                    component: AnnouncementEdit,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'resources',
                    component: Resources,
                    meta: { requiresAuth: true },
                    children: [
                        {
                            path: '',
                            name: 'resource.photos',
                            component: ResourcePhotos,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'photos/new-album',
                            name: 'new-album',
                            component: NewAlbum,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'photos/:album_id',
                            name: 'resource.photos.album',
                            component: PhotosAlbumView,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'photos/:album_id/edit',
                            name: 'resource.photos.album.edit',
                            component: PhotosAlbumEdit,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'audios',
                            name: 'resource.audios',
                            component: ResourceAudios,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'audios/add',
                            name: 'resource.audios.new',
                            component: AudioAdd,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'audios/edit/:audio_id',
                            name: 'resource.audios.edit',
                            component: AudioAdd,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'audios/view/:audio_id',
                            name: 'resource.audios.view',
                            component: AudioView,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'videos',
                            name: 'resource.videos',
                            component: ResourceVideos,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'videos/new',
                            name: 'resource.videos.new',
                            component: AddVideo,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'videos/edit/:video_id',
                            name: 'resource.videos.edit',
                            component: AddVideo,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'videos/view/:video_id',
                            name: 'resource.videos.view',
                            component: VideoView,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'documents',
                            name: 'resource.docs',
                            component: ResourceDocs,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'documents/new',
                            name: 'resource.docs.new',
                            component: AddDocument,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'documents/edit/:doc_id',
                            name: 'resource.docs.edit',
                            component: AddDocument,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'documents/view/:doc_id',
                            name: 'resource.docs.view',
                            component: DocumentView,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                    ]
                },
                {
                    path: 'links',
                    name: 'entity.links',
                    component: Links,
                    props: true,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'links/add',
                    name: 'entity.links.add',
                    component: LinkAdd,
                    props: true,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'links/edit/:link_id',
                    name: 'entity.links.edit',
                    component: LinkAdd,
                    props: true,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'links/view/:link_id',
                    name: 'entity.links.view',
                    component: LinkView,
                    props: true,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'events',
                    name: 'entity.events',
                    component: Events,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'contributions',
                    name: 'entity.contributions',
                    component: Contributions,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'my-congress',
                    name: 'entity.my-congress',
                    component: MyCongress,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'configuration',
                    name: 'entity.config',
                    component: Configuration,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'roles',
                    name: 'entity.roles',
                    component: EntityRole,
                    meta: { requiresAuth: true },
                }
            ]
        },

        // Collection Profile
        {
            path: '/collection/:collection_id',
            component: CollectionProfile.Landing,
            props: true,
            children: [
                {
                    props: true,
                    path: 'members/:id',
                    name: 'CollectionProfile',
                    component: CollectionProfile.Profile,
                    children: [
                        {
                            path: 'about',
                            name: 'CollectionProfile.about',
                            component: CollectionProfile.About,
                            props: true
                        },
                        {
                            path: 'contact',
                            name: 'CollectionProfile.contact',
                            component: CollectionProfile.Contact,
                            props: true
                        },
                        {
                            path: 'citizenships',
                            name: 'CollectionProfile.citizenships',
                            component: CollectionProfile.Citizenship,
                            props: true
                        },
                        {
                            path: 'memberships',
                            name: 'CollectionProfile.memberships',
                            component: CollectionProfile.Membership,
                            props: true
                        },
                        {
                            path: 'employments',
                            name: 'CollectionProfile.employments',
                            component: CollectionProfile.Employments,
                            props: true
                        },
                        {
                            path: 'educations',
                            name: 'CollectionProfile.educations',
                            component: CollectionProfile.Educations,
                            props: true
                        },
                        {
                            path: 'skills',
                            name: 'CollectionProfile.skills',
                            component: CollectionProfile.Skills,
                            props: true
                        },
                        {
                            path: 'social',
                            name: 'CollectionProfile.social',
                            component: CollectionProfile.Social,
                            props: true
                        }
                    ]
                }
            ]
        },

        // Entity Global
        {
            path: '/entity/:entity_id',
            component: Entity,
            props: true,
            meta: { requiresAuth: true, entityGlobal: true },
            children: [
                {
                    path: 'members',
                    name: 'entityGlobal.entity.members',
                    component: Members,
                    props: true,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'join-requests',
                    name: 'entityGlobal.entity.joinRequests',
                    component: JoinRequests,
                    props: true,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'dashboard',
                    name: 'entityGlobal.entity.dashboard',
                    component: EntityDashboard,
                    props: true,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'entities',
                    name: 'entityGlobal.entity.entities',
                    component: Entities,
                    props: true,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'members/:id',
                    component: MemberProfile,
                    props: true,
                    meta: { requiresAuth: true },
                    children: [
                        {
                            path: 'about',
                            name: 'entityGlobal.profile.index',
                            component: About,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'contact',
                            name: 'entityGlobal.profile.contact',
                            component: Contact,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'citizenship',
                            name: 'entityGlobal.profile.citizenship',
                            component: Citizenship,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'family',
                            name: 'entityGlobal.profile.family',
                            component: Family,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'membership',
                            name: 'entityGlobal.profile.membership',
                            component: Membership,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'employment',
                            name: 'entityGlobal.profile.employments',
                            component: Employments,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'education',
                            name: 'entityGlobal.profile.educations',
                            component: Educations,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'skills',
                            name: 'entityGlobal.profile.skills',
                            component: Skills,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'social',
                            name: 'entityGlobal.profile.social',
                            component: Social,
                            meta: { requiresAuth: true },
                        }
                    ]
                },
                {
                    path: 'member/:id/notes',
                    component: MemberNotes,
                    name: 'entityGlobal.member.notes',
                    props: true,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'calendar',
                    name: 'entityGlobal.entity.calendar',
                    component: Calendar,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'announcements',
                    name: 'entityGlobal.entity.announcements',
                    component: Announcements,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'announcements/new',
                    name: 'entityGlobal.entity.announcements.new',
                    component: NewAnnouncement,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'announcements/:announcement_id/view',
                    name: 'entityGlobal.entity.announcements.view',
                    component: AnnouncementsView,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'announcements/:announcement_id/edit',
                    name: 'entityGlobal.entity.announcements.edit',
                    component: AnnouncementEdit,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'resources',
                    component: Resources,
                    meta: { requiresAuth: true },
                    children: [
                        {
                            path: '',
                            name: 'entityGlobal.resource.photos',
                            component: ResourcePhotos,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'photos/new-album',
                            name: 'entityGlobal.new-album',
                            component: NewAlbum,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'photos/:album_id',
                            name: 'entityGlobal.resource.photos.album',
                            component: PhotosAlbumView,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'photos/:album_id/edit',
                            name: 'entityGlobal.resource.photos.album.edit',
                            component: PhotosAlbumEdit,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'audios',
                            name: 'entityGlobal.resource.audios',
                            component: ResourceAudios,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'audios/add',
                            name: 'entityGlobal.resource.audios.new',
                            component: AudioAdd,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'audios/edit/:audio_id',
                            name: 'entityGlobal.resource.audios.edit',
                            component: AudioAdd,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'audios/view/:audio_id',
                            name: 'entityGlobal.resource.audios.view',
                            component: AudioView,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'videos',
                            name: 'entityGlobal.resource.videos',
                            component: ResourceVideos,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'videos/new',
                            name: 'entityGlobal.resource.videos.new',
                            component: AddVideo,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'videos/edit/:video_id',
                            name: 'entityGlobal.resource.videos.edit',
                            component: AddVideo,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'videos/view/:video_id',
                            name: 'entityGlobal.resource.videos.view',
                            component: VideoView,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'documents',
                            name: 'entityGlobal.resource.docs',
                            component: ResourceDocs,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'documents/new',
                            name: 'entityGlobal.resource.docs.new',
                            component: AddDocument,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'documents/edit/:doc_id',
                            name: 'entityGlobal.resource.docs.edit',
                            component: AddDocument,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                        {
                            path: 'documents/view/:doc_id',
                            name: 'entityGlobal.resource.docs.view',
                            component: DocumentView,
                            props: true,
                            meta: { requiresAuth: true },
                        },
                    ]
                },
                {
                    path: 'links',
                    name: 'entityGlobal.entity.links',
                    component: Links,
                    props: true,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'links/add',
                    name: 'entityGlobal.entity.links.add',
                    component: LinkAdd,
                    props: true,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'links/edit/:link_id',
                    name: 'entityGlobal.entity.links.edit',
                    component: LinkAdd,
                    props: true,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'links/view/:link_id',
                    name: 'entityGlobal.entity.links.view',
                    component: LinkView,
                    props: true,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'events',
                    name: 'entityGlobal.entity.events',
                    component: Events,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'contributions',
                    name: 'entityGlobal.entity.contributions',
                    component: Contributions,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'my-congress',
                    name: 'entityGlobal.entity.my-congress',
                    component: MyCongress,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'configuration',
                    name: 'entityGlobal.entity.config',
                    component: Configuration,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'roles',
                    name: 'entityGlobal.entity.roles',
                    component: EntityRole,
                    meta: { requiresAuth: true },
                }
            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js